module.exports = __webpack_public_path__ + "static/media/SAS Alert Tone 12.5643d56c.mp3";